import { LoadingSpinner } from '@kanda-libs/ks-design-library';
import type { ContractRequestBodyBody } from '@kanda-libs/ks-frontend-services/src/service/external';
import TermsAndConditionsRenderBody from './components/Body';
import TermsAndConditionsActions from './TermsAndConditionsActions';
import useFetchTermsAndConditionsTerms from './useFetchTermsAndConditionsTerms';

export interface TermsAndConditionsRenderProps {
  body: ContractRequestBodyBody | undefined;
}

const TermsAndConditionsRender: React.FunctionComponent<TermsAndConditionsRenderProps> =
  function ({ body }) {
    const { contract, error, isLoading, isFetching, onClick } =
      useFetchTermsAndConditionsTerms(body);
    return (
      <>
        {!isLoading && !error && contract && (
          <TermsAndConditionsActions
            onClick={onClick}
            isFetching={isFetching}
          />
        )}
        <div className="relative flex flex-col w-full pb-[150%] md:pb-[120%] aspect-auto bg-neutral-300 shadow-[rgba(0,0,0,0.1)_0px_0px_5px_2px]">
          <div className="absolute w-full h-full top-0 left-0 overflow-y-scroll px-2 md:px-8">
            {isLoading ? (
              <div className="w-full h-full m-auto pt-10">
                <LoadingSpinner stroke="purple-400" className="mx-auto" />
              </div>
            ) : (
              <div className="flex flex-col gap-y-2 my-2 md:my-8 bg-neutral-000 p-4 md:p-12">
                {!isLoading && error && <p>{error}</p>}
                {!isLoading && !error && contract && (
                  <TermsAndConditionsRenderBody content={contract} />
                )}
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

export default TermsAndConditionsRender;
